// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportSummaryGroupDtoCardStatusSummaryRecordDto } from './IReportSummaryGroupDtoCardStatusSummaryRecordDto';
import {
    IReportSummaryGroupDtoCardStatusSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoCardStatusSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoCardStatusSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoCardStatusSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoCardStatusSummaryRecordDto';
import type { ICardStatusSummaryRecordDto } from './ICardStatusSummaryRecordDto';
import {
    ICardStatusSummaryRecordDtoFromJSON,
    ICardStatusSummaryRecordDtoFromJSONTyped,
    ICardStatusSummaryRecordDtoToJSON,
    ICardStatusSummaryRecordDtoToJSONTyped,
} from './ICardStatusSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoCardStatusSummaryRecordDto
 */
export interface IReportSummaryDtoCardStatusSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoCardStatusSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<ICardStatusSummaryRecordDto>}
     * @memberof IReportSummaryDtoCardStatusSummaryRecordDto
     */
    employer_records?: Array<ICardStatusSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoCardStatusSummaryRecordDto>}
     * @memberof IReportSummaryDtoCardStatusSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoCardStatusSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoCardStatusSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoCardStatusSummaryRecordDto(value: object): value is IReportSummaryDtoCardStatusSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoCardStatusSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoCardStatusSummaryRecordDto {
    return IReportSummaryDtoCardStatusSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoCardStatusSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoCardStatusSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(ICardStatusSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoCardStatusSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoCardStatusSummaryRecordDtoToJSON(json: any): IReportSummaryDtoCardStatusSummaryRecordDto {
    return IReportSummaryDtoCardStatusSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoCardStatusSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoCardStatusSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(ICardStatusSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoCardStatusSummaryRecordDtoToJSON)),
    };
}

